import React from "react";
import { useNavigate } from "react-router-dom";
import "./Slider.css";
import logo from "../../assets/logo.png";

const Slider = () => {
  const navigate = useNavigate();

  return (
    <section className="hero">
      {/* LEFT SIDE */}
      <div className="hero-left">
        <span className="accent-line"></span>

        <h2 className="typing-text">
          Where Innovation Meets Execution
        </h2>

        <h1>
          <span className="brand-blue">Vijay</span>{" "}
          <span className="brand-orange">
            Software Solutions Pvt Ltd
          </span>
        </h1>

        <p>
          We deliver secure, scalable, and intelligent IT solutions that help
          organizations innovate, grow, and succeed in the digital era.
        </p>

        <button onClick={() => navigate("/contact")}>
          Get in Touch
        </button>
      </div>

      {/* RIGHT SIDE */}
      <div className="hero-right values-container">
        {/* CENTER LOGO */}
   <div className="center-logo">
  <img src={logo} alt="Vijay Software Solutions Logo" />
</div>

        {/* VALUE CARDS */}
        <div className="value-card card-1">
          <h4>Innovate for Good</h4>
          <span>CORE MOTTO</span>
        </div>

        <div className="value-card card-2">
          <h4>Define the Future</h4>
          <span>VISION</span>
        </div>

        <div className="value-card card-3">
          <h4>Engineering Excellence</h4>
          <span>OUR CRAFT</span>
        </div>

        <div className="value-card card-4">
          <h4>Limitless Scale</h4>
          <span>CAPABILITY</span>
        </div>

        <div className="value-card card-5">
          <h4>Dream Bigger</h4>
          <span>MOTIVATION</span>
        </div>

        <div className="value-card card-6">
          <h4>Global Impact</h4>
          <span>PURPOSE</span>
        </div>
      </div>
    </section>
  );
};

export default Slider;
